import { ArrowUpRight } from "lucide-react";
import { BOOKING_URL } from "@/lib/constants";

export default function FooterCTA() {
  return (
    <section
      data-testid="footer-cta-banner"
      className="bg-[#F5F5F5] border-y border-[#e5e7eb]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-8">
          <span className="ash-eyebrow">Begin Treatment</span>
          <h2 className="mt-4 text-4xl md:text-6xl font-bold leading-[1.05] text-[#080808] tracking-tight">
            Ready To Start Feeling Better?
          </h2>
          <p className="mt-6 text-lg text-[#3C4048] max-w-2xl leading-relaxed">
            Book directly with our therapists through our secure booking system.
            Most insurance plans accepted.
          </p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <a
            href={BOOKING_URL}
            data-testid="footer-cta-book-button"
            className="ash-btn-primary"
          >
            Book Your Session
            <ArrowUpRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
}
